export default __webpack_public_path__ + "static/media/logo-netflix.41468e1b.svg";